import React from 'react';
import "tabler-react/dist/Tabler.css";
import { Site,AccountDropdown } from "tabler-react";

function Header({profile}) {
  return (
    <>
        <Site.Header>
          <a href="/">
            <Site.Logo src="media/IEU_blanco.png"></Site.Logo>
          </a>
          <AccountDropdown
              avatarURL="media/m-user.svg"
              name={profile.fullname}
              description="Docente"
              options={[
                { icon: "home", value: "General", to: "/" },
                { icon: "book", value: "Mis Cursos", to: "/mis-cursos" },
                { icon: "edit-2", value: "Actividades", to: "/actividades" },
                { icon: "user", value: "Perfil del alumno", to: "/perfil-del-alumno" },
                { icon: "log-in", value: "Ingresar a Plataformas", to: "/ingresar-a-plataformas" },
                "divider",
                { icon: "log-out", value: "Cerrar sesión", to: "/logout" },
              ]}
            />
        </Site.Header>
    </>
  );
}

export default Header;